const generateUniquePath = (pages, rawPath, locale) => {
  const slashesRegExp = /^\/+|\/+$/g;
  const reservedPath = ['/ws/', '/e/'];
  const trimmedPath = rawPath.replace(slashesRegExp, '');
  const path = locale ? `/${locale}/${trimmedPath}/` : `/${trimmedPath}/`;
  const pathPrefix = locale ? `/${locale}/${trimmedPath}-` : `/${trimmedPath}-`;
  let newPathIndex = 0;
  const uniquePath = pages.reduce((newPath, page) => {
    if (page.path === path || reservedPath.includes(newPath)) {
      return newPath.startsWith(pathPrefix) ? newPath : `${pathPrefix}2/`;
    }

    if (!page.path || !page.path.startsWith(pathPrefix)) return newPath;

    const pathSuffix = page.path.replace(pathPrefix, '').replace(slashesRegExp, '');
    const pathIndex = Number(pathSuffix);

    if (!pathIndex || newPathIndex > pathIndex + 1) {
      return newPath;
    }

    newPathIndex = pathIndex + 1;

    return `${pathPrefix}${newPathIndex}/`;
  }, path);

  return uniquePath;
};

export default generateUniquePath;
